import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuthUser from '../services/useAuthUser';
import { useSubscription } from '../hooks/useSubscription';
import { hasTierAccess } from '../config/featureAccess';

const ProtectedRoute = ({
  children,
  requiredTier = 'free',
  redirectTo = '/auth',
}) => {
  const { user, loading: authLoading } = useAuthUser();
  const { entitlements, effectiveTier, loading: subscriptionLoading } = useSubscription();
  const location = useLocation();

  if (authLoading || subscriptionLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  if (!hasTierAccess(requiredTier, entitlements)) {
    return (
      <Navigate
        to="/"
        state={{
          from: location,
          scrollToPricing: true,
          requiredTier,
          currentTier: effectiveTier,
        }}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute; 